/**
 * The localStorage keys that survive an identity boundary. Everything else in
 * browser storage is deleted at logout, so a key belongs here only when it
 * describes the device and nothing about the account: no identity, no
 * credential, no user content. When in doubt, leave it out — the cost of
 * deleting a device preference is a flash of default UI; the cost of keeping an
 * account value is a CASA 6.6.1 finding.
 *
 * A leaf module with no imports, so the session-ending code that reads it
 * never pulls a feature module (and its import-time side effects) into the
 * HTTP bootstrap.
 */

/**
 * Whether this browser has been seen scrolling by wheel, trackpad or touch.
 * Dropping it would show the next visitor a native scrollbar until their first
 * scroll; it carries nothing about who they are.
 */
export const SCROLL_CAPABILITY_STORAGE_KEY = "okthx:can-scroll-without-bar";

export const DEVICE_SCOPED_LOCAL_STORAGE_KEYS: readonly string[] = [SCROLL_CAPABILITY_STORAGE_KEY];
